import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';
import { getApiBaseUrl } from '../services/api';

export const authClient = createAuthClient({
  baseURL: getApiBaseUrl(),
  plugins: [magicLinkClient()],
});

export default authClient;
